export var PROPERTY_TYPE_EN;
(function (PROPERTY_TYPE_EN) {
    PROPERTY_TYPE_EN["ALL"] = "All properties";
    PROPERTY_TYPE_EN["KERBSIDE"] = "Kerbside properties";
    PROPERTY_TYPE_EN["FLATS_WITH_COMMUNAL_BINS"] = "Flats with communal bins";
    PROPERTY_TYPE_EN["FLATS_WITH_INDIVIDUAL_BINS"] = "Flats with individual bins or bags";
    PROPERTY_TYPE_EN["NARROW_ACCESS"] = "Narrow access/difficult to reach/remote properties";
})(PROPERTY_TYPE_EN || (PROPERTY_TYPE_EN = {}));
export var PROPERTY_TYPE_CY;
(function (PROPERTY_TYPE_CY) {
    PROPERTY_TYPE_CY["ALL"] = "Pob eiddo";
    PROPERTY_TYPE_CY["KERBSIDE"] = "Eiddo ymyl y ffordd";
    PROPERTY_TYPE_CY["FLATS_WITH_COMMUNAL_BINS"] = "Mynediad cul/anodd eu cyrraedd/eiddo anghysbell";
    PROPERTY_TYPE_CY["FLATS_WITH_INDIVIDUAL_BINS"] = "Fflatiau gyda biniau neu fagiau unigol";
    PROPERTY_TYPE_CY["NARROW_ACCESS"] = "Fflatiau gyda biniau cymunedol";
})(PROPERTY_TYPE_CY || (PROPERTY_TYPE_CY = {}));
